import React from "react";
import { Controller } from "react-hook-form";
import Select from "react-select";
import { selectStyle } from "../../../shared/fixtures/select_style";
import { P } from "../Texts";

export const SearchSelect = (props) => {
  return (
    <>
      <label htmlFor={props.name}>
        <P fontSize="14px" fontFamily="semi" color="#47495C" className="mb-2">
          {props.label}
          {props.isRequired && (
            <span
              className=""
              style={{
                color: "#E62250",
              }}
            >
              *
            </span>
          )}
        </P>
      </label>

      <Controller
        defaultValue={[]}
        {...props}
        control={props.control}
        render={({ field }) => (
          <Select
            styles={selectStyle}
            {...field}
            isMulti={props.isMulti}
            options={props.options}
            onChange={field.onChange}
          />
        )}
        rules={props.validation}
      />
    </>
  );
};
